import axios from 'axios';

const baseUrl = process.env.REACT_APP_AWS_API_GATEWAY_URL;


export const fetchDataDocs = (accessToken, variables, id_user_action) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`
        },
        data: JSON.stringify({
            'id_user_action': id_user_action,
            'variables': JSON.stringify(variables)
        })
    })
}


//#region SHARED DETAILS TABLE
export const fetchDetails = (accessToken, id, variables) => {
    return axios({
        method: "POST",
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
        data: JSON.stringify({
            'id_user_action': id,
            'variables': JSON.stringify(variables)
        })
    })
}
//#endregion